import LogoSvg from '@/assets/wntd-wordmark-orange.svg';

interface LookShareCardProps {
  imageUrl?: string;
  userName?: string;
}

export function LookShareCard({ imageUrl, userName }: LookShareCardProps) {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#0a0a0a',
        padding: '48px 48px 40px',
      }}
    >
      {/* Main try-on image — fills most of the 9:16 card */}
      <div
        style={{
          flex: 1,
          borderRadius: 32,
          overflow: 'hidden',
          position: 'relative',
          backgroundColor: '#1a1a1a',
        }}
      >
        {imageUrl ? (
          <img
            src={imageUrl}
            alt="Virtual try-on"
            crossOrigin="anonymous"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        ) : (
          <div
            style={{
              width: '100%',
              height: '100%',
              background: 'linear-gradient(135deg, #FF5C4D 0%, #FF6F3B 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <span style={{ fontSize: 72, fontWeight: 700, color: 'white' }}>✨</span>
          </div>
        )}
        
        {/* Gradient overlay at bottom */}
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: 200,
            background: 'linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 100%)',
          }}
        />
        
        {/* "Virtual Try-On" badge */}
        <div
          style={{
            position: 'absolute',
            top: 28,
            left: 28,
            backgroundColor: 'rgba(0,0,0,0.6)',
            backdropFilter: 'blur(10px)',
            borderRadius: 20,
            padding: '10px 22px',
            display: 'flex',
            alignItems: 'center',
            gap: 10,
          }}
        >
          <span style={{ fontSize: 22 }}>✨</span>
          <span style={{ fontSize: 20, fontWeight: 600, color: 'white' }}>Virtual Try-On</span>
        </div>
        
        {/* Attribution at bottom */}
        <div
          style={{
            position: 'absolute',
            bottom: 28,
            left: 28,
            right: 28,
          }}
        >
          <p style={{ fontSize: 26, fontWeight: 600, color: 'white' }}>
            {userName ? `Try-on by @${userName}` : 'My virtual try-on'}
          </p>
        </div>
      </div>

      {/* Footer with branding */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingTop: 28,
          flexShrink: 0,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <img src={LogoSvg} alt="WNTD" style={{ height: 36 }} />
          <span style={{ fontSize: 22, color: 'rgba(255,255,255,0.5)', fontWeight: 500 }}>
            Created with WNTD
          </span>
        </div>
        <span style={{ fontSize: 22, color: 'rgba(255,255,255,0.4)', fontWeight: 400 }}>wntd.ai</span>
      </div>
    </div>
  );
}
